<template>
  <div id="card-propiedades" :class="className" class="px-0 my-2 py-0  justify-content-center"   > 
    <!-- <div  class="shadow_card rounded-bottom bg-card px-0 card-div altura-card "   >
    
      <imgCard class="card-comun"></imgCard>
      <detailCardAgent></detailCardAgent>
       
    
    </div> -->
    <div class="d-flex "   >
      
      <imgCard :detailCardAgente="product" style="border-top-left-radius: 10px !important; border-bottom-left-radius: 10px !important; border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;" class="card-comun p-0"></imgCard>
      
      <detailCardAgent :detailCardAgente="product" :detail="detail" class="px-4 text-left center-vertical" style="   width:100%;  border-top-left-radius: 10px !important; border-bottom-left-radius: 10px !important; border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;"></detailCardAgent>
  
    </div>


  
  </div>
</template>

<script>
import imgCard from "../components/ImgCardAgent.vue";
import detailCardAgent from "../components/detailCardAgent.vue";

function safeParseLocalStorageJson(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw || raw === "undefined" || raw === "null") {
      return fallback;
    }
    return JSON.parse(raw);
  } catch (error) {
    localStorage.removeItem(key);
    return fallback;
  }
}

export default {
  props: ["product", "theme", "detail"],
  components: {imgCard, detailCardAgent },
  data: () => ({
    className: "product",
    user: null
  }),
  mounted() {
    this.user = safeParseLocalStorageJson("user", false); //this.$store.state.user!=null ? true : false;
    if (this.theme) {
      this.className = this.theme;
    }
  },
  methods:{
    goto(rutaWeb){
      console.log('goto ruta: ', rutaWeb)
      console.log('goto ruta: ', this.product)
      if(this.product.privado== 1 && !this.user.id){
        this.$router.push('/opps/product')
      }
      else{
        if((this.product.categoria_id== 4 || this.product.categoria_id== 8) && this.product.documento_descargable_tar != null){
          window.location.href = this.product.documento_descargable_tar
          //window.open(this.product.documento_descargable_tar)
        }
        else{
          if(rutaWeb.includes('http')){
            console.log('web', rutaWeb)
            window.open(rutaWeb)
          }
          else{
            window.location.href =rutaWeb
            console.log('in', rutaWeb)
          }      
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>

///////////////////////////////

#card-propiedades{

  }
  #card-propiedades :hover h3{
    transition: all  0.2s ease; /* Transición suave para todos los cambios */

  // transition: all  0.7s ease; /* Transición suave para todos los cambios */

    color: var(--primary) !important;
  }
  
  .shadow_card {
    background: transparent;
    box-shadow: 0 .2rem .8rem rgba(0, 0, 0, 0.048)!important;
  }

  .rounded-card-right{
    border-top-right-radius: 10px;
  }
  .rounded-card-right-b{
    border-bottom-right-radius: 10px;
  }

.altura-card{
  height: 100% !important;
  width: 100% !important;
  display:inline-block;
}
.altura-card-detalle{
  height: 15rem !important;
  
}
.altura-card-detalle-propiedades{
  height: 12rem !important;
  
}
.altura-card-footer-propiedades{
  height: auto !important;
  
}
.altura-card-boton{
  height: 50px !important;
  margin-top: 35px;
  margin-left: 15px;
}


  .text-card1{
    height: 100px;
  }
  
  .text-card1 {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

/////////////////
$primary: rgba(255, 0, 119, 1);

.text-card{
  height: 70px;
}

.text-card {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}


.bg-image-card {

  // border-top-right-radius: 10px;
  background-color: #cccccc;
  height: 18rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.radius-border{
  border-top-right-radius: 15px !important;
}

.radius-border-left-bottton{
  border-bottom-right-radius: 15px !important;
}
h4 {
  color: $primary;
}

.product-alt {
  background: transparent;
  border: 1px solid $primary;
  border-radius: var(--radius);
  margin: 1rem;
  padding: 1rem;
  color: #fff;
}
.productimg{
  height:10rem; width:80%; display:block; margin:auto
}

@media screen and (max-width: 600px) {
  .productimg{
    height:10rem; width:50%; display:block; margin:auto
  }
}
</style>
